import { Button } from '../../UI';

export const BottomNav = (props: {
  className?: string;
  setPositionAbsolute?: boolean;
  showBackButton?: boolean;
  isNavigationDisabled?: boolean;
  isContinueButtonLoading?: boolean;
  onBackClick?: any;
  onSkipClick?: any;
  onContinueClick?: any;
  showSetDefaultWorkspace?: boolean;
  selectDefaultWorkspace?: any;
  isSelectedDefaultWorkspace?: boolean;
}) => {
  const handleBackClick = () => {
    if (props.onBackClick) {
      props.onBackClick();
    }
  };

  const handleSkipClick = () => {
    if (props.onSkipClick) {
      props.onSkipClick();
    }
  };

  const handleContinueClick = () => {
    if (props.onContinueClick && !props.isNavigationDisabled) {
      props.onContinueClick();
    }
  };

  return (
    <div
      className={`${
        props.setPositionAbsolute ? 'absolute' : 'fixed'
      } bottom-0 left-0 flex justify-center items-center w-full bg-white border-t border-grey-10 ${
        props.className || ''
      }`}
    >
      <div className="relative flex justify-center items-center w-full">
        {props.showBackButton && (
          <Button
            buttonClass="absolute left-4 font-bold"
            type="button"
            onClick={handleBackClick}
          >
            <span className="material-icons text-lg font-extrabold mr-3">
              west
            </span>
            Back
          </Button>
        )}
        {props.onSkipClick !== undefined && !props.showSetDefaultWorkspace && (
          <Button
            buttonClass="font-bold text-grey-50"
            type="button"
            onClick={handleSkipClick}
          >
            Skip and do it later
          </Button>
        )}
        {props.showSetDefaultWorkspace && (
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={props.isSelectedDefaultWorkspace}
              onChange={() =>
                props.selectDefaultWorkspace(!props.isSelectedDefaultWorkspace)
              }
              className="mr-1.5"
            />
            <span className="ml-2 text-black text-sm font-light dark:text-white">
              {`Set as default workspace and don't show it again`}
            </span>
          </div>
        )}
        <Button
          buttonClass="absolute right-4 w-32"
          type="button"
          variant="primary"
          size="large"
          disabled={props.isNavigationDisabled}
          loading={props.isContinueButtonLoading}
          onClick={handleContinueClick}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
